// Shared constants & pure helpers for the admin Invoices page.

export const statusConfig = {
  open: { label: 'Open', color: 'bg-yellow-100 text-yellow-800' },
  ready_for_payment: { label: 'Ready to Pay', color: 'bg-blue-100 text-blue-800' },
  amend_for_review: { label: 'Adjustment Pending', color: 'bg-purple-100 text-purple-800' },
  amended_ready_for_payment: { label: 'Amended', color: 'bg-blue-100 text-blue-800' },
  processing_payment: { label: 'Processing', color: 'bg-yellow-100 text-yellow-800' },
  payment_processing: { label: 'ACH Processing', color: 'bg-yellow-100 text-yellow-800' },
  paid: { label: 'Paid', color: 'bg-green-100 text-green-800' },
  overdue: { label: 'Overdue', color: 'bg-red-100 text-red-800' },
  cancelled: { label: 'Cancelled', color: 'bg-gray-100 text-gray-800' },
  void: { label: 'Void', color: 'bg-gray-100 text-gray-800' },
};

export const PAYMENT_TYPES = [
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'check', label: 'Check' },
  { value: 'cash', label: 'Cash' },
  { value: 'gift_card', label: 'Gift Card' },
  { value: 'other', label: 'Other' },
];

export const isOverdue = (inv) => {
  if (!['open', 'ready_for_payment'].includes(inv.status)) return false;
  return new Date(inv.due_date) < new Date();
};

export const getEffectiveStatus = (inv) => (isOverdue(inv) ? 'overdue' : inv.status);
